module.exports = __webpack_public_path__ + "img/zphdz.fc3e9980.png";